module.exports = __webpack_public_path__ + "static/media/analysis_tab.99584771.png";